import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteFleet($id: ID!) {
        deleteFleet(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
